import { ModuleWithProviders, NgModule } from '@angular/core';
import { DeepPartial } from '@df/util/type/deep-partial';
import { DfImageWrapperComponent } from './df-image-wrapper.component';
import { DfImageDirective } from './df-image.directive';
import { NDfModuleImage } from './df-module-image.interface';
import { providers } from './image.providers';

@NgModule({
    imports: [DfImageDirective, DfImageWrapperComponent],
    exports: [DfImageDirective, DfImageWrapperComponent]
})
export class DfModuleImageModule {
    static forRoot(config?: DeepPartial<NDfModuleImage.IConfig>): ModuleWithProviders<DfModuleImageModule> {
        return {
            ngModule: DfModuleImageModule,
            providers: providers(config)
        };
    }
}
